import { useCallback } from "react";
import axios from 'axios';
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

export default function useAccount() {
  const submitUserAccountRequest = useCallback(async (request) => {
    const response = await axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/useraccessrequest`, request);

    // axios is configured to treat 4xx as a resolved (non-throwing) response, so we must
    // check the status ourselves — otherwise callers can't tell a validation failure from success.
    if (response.status < 200 || response.status >= 300) {
      const err = new Error("Unable to submit user account request");
      err.response = response;
      throw err;
    }

    return response.data;
  }, []);

  const approveUserAccountRequest = async (approval) => {
    const response = await axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/useraccessrequest/approve`, approval);

    // axios is configured to treat 4xx as a resolved (non-throwing) response, so we must
    // check the status ourselves — otherwise a refused access-level change looks saved.
    if (response.status < 200 || response.status >= 300) {
      const err = new Error("Unable to approve user account request");
      err.response = response;
      throw err;
    }

    return response.data;
  }

  const denyUserAccountRequest = async ({ requestId, denialReason }) => {
    const payload = denialReason ? { denialReason } : {};
    const response = axios.post(
      `${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/useraccessrequest/deny/${requestId}`,
      payload
    );
    return (await response).data;
  }

  const getUserAccountRequests = useCallback(async (isPending) => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/useraccessrequest/list?isPending=${isPending}`);
    return (await response).data;
  }, []);

  const getAppUser = useCallback(async () => {
    return axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/appuser`);
  }, []);

  const getUserAccessRequest = async () => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/useraccessrequest`);
    return (await response).data;
  };

  return {
    getUserAccessRequest,
    getUserAccountRequests,
    submitUserAccountRequest,
    approveUserAccountRequest,
    denyUserAccountRequest,
    getAppUser
  };
}
